import type { CustomerAuthField } from './validation.types'

export const TAX_CODE_REGEX = /^[A-Z0-9]{11,16}$/
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const POSTAL_CODE_REGEX = /^[A-Za-z0-9-]{4,10}$/

export const TOTAL_SIGNUP_STEPS = 4

export const SIGNUP_STEP_FIELDS: Record<number, CustomerAuthField[]> = {
  1: ['firstName', 'lastName', 'taxCode', 'gender', 'email'],
  2: [
    'phonePrefix',
    'phoneLocalNumber',
    'addressStreet',
    'addressStreetNumber',
    'addressCity',
    'addressPostalCode',
    'addressProvince',
    'addressCountry',
  ],
  3: [],
  4: [],
}

export const LOGIN_FIELDS: CustomerAuthField[] = ['email', 'password']
